import { API_URL } from '../../environment';
import { ducksActionCreator } from '../ducksHelpers';

export const upcomingAppointmentsSettings = {
  stateName: 'upcomingAppointments',
  dataType: 'object',
  actions: {
    fetch: 'ducks/clients/FETCH_UPCOMING_APPOINTMENTS',
  },
};

// Action Creators
export function fetchUpcomingAppointments(
  params = '',
  callback = () => {},
  errorCallback = () => {},
) {
  return ducksActionCreator(
    upcomingAppointmentsSettings.actions.fetch,
    'get',
    `${API_URL}/practice/appointments/paginated_index?upcoming=true${params}`,
    {},
    true,
    callback,
    errorCallback,
  );
}
